import React from 'react'
import Link from 'gatsby-link'

import './footer.css'

const Footer = () => (
  <div
    style={{
      background: '#000040',
      color: '#fff',
      marginTop: '1.45rem',
      padding: '80px 0 25px 0'
    }}
  >
    <div className="footer container">

      <div className="row">
        <div className="col-md-6 col-lg-3">
          <h3>Free quotations</h3>

          <p>Please get in contact and one of our helpful team can provide you with 
            a no obligation, fee free quotation.</p>
          <p><strong>Call us on 07484 259007</strong></p>
        </div>

        <div className="col-md-6 col-lg-3">
          <h3>Areas</h3>

          <ul>
            <li>Hertfordshire</li>
            <li>Essex</li>
            <li>North London</li>
            <li>Cambridgeshire</li>
          </ul>
        </div>

        <div className="col-md-6 col-lg-3">
          <h3>Services</h3>

          <ul>
            <li>Home Extensions</li>
            <li>Refurbishment</li>
            <li>Property Maintenance</li>
            <li>Home Improvements</li>
          </ul>
        </div>

        <div className="col-md-6 col-lg-3">
          <h3>Contact us</h3>

          <p>Telephone: <br/>
          07484 259007</p>

          <p>Email:<br/>
            <a href="mailto:glenn@ridleyowenandsons.com">glenn@ridleyowenandsons.com</a>
          </p>
        </div>
      </div>

      <div className="row" style={{ marginTop: '50px' }}>
        <div className="col-sm-6">
          <span>Copyright &copy; 2018 Ridley Owen & Sons</span>
        </div>

        <div className="col-sm-6 text-sm-right">
          Find us on <a href="https://www.facebook.com/ridleyowenandsons/">Facebook</a>
        </div>
      </div>

    </div>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js